module.exports = __webpack_public_path__ + "prod/1.42.2/img/beike-icon.bd08f8cf.png";